var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("소식 종류")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.getNewsTypeText(_vm.newsType))+"\n    "),(_vm.newsType === 'CUSTOM')?[_vm._v("("+_vm._s(_vm.getCustomNewsText(_vm.customNewsType))+")")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }